const initialState ={
  reportData:[],
  showerror:false,
  errmessage:"",
  clientBasedValues:[],
  processBasedValue:[]
}
export default (state = initialState, action) => {
  switch (action.type) {
  case 'CLID_REPORT_ACTION_GENERATE':
    return Object.assign({}, state, {
      reportData: action.reportData,
      isPending: action.isPending
  })
  case 'RESET_REPORT_ACTION':
    return Object.assign({}, state, {
      reportData: action.reportData,
  })
  case 'REPORT_ACTION_ERROR':
    return Object.assign({}, state, {
      errmessage: action.message,
      showerror: action.showerror,
      isPending: action.isPending,      
      reportData: action.reportData
    })
  case 'CLID_REPORT_ACTION_PENDING':
    return Object.assign({}, state, {
      isPending: action.isPending
    })
  case 'WEB_FORM_MAPPED_NAMES':
    return Object.assign({}, state, {
      webFormNames: action.webFormNames,
      isPending: action.isPending
    })
    case 'CLIENT_BASED_VALUES':
      return Object.assign({}, state, {
        clientBasedValues: action.clientBasedValues,
        isPending: action.isPending
      })
    case 'PROCESS_BASED_VALUES':
      return Object.assign({}, state, {
        processBasedValue: action.processBasedValue,
        isPending: action.isPending
      })
  case "REPORT_ACTION_MODAL_CLOSE":
    return Object.assign({}, state, {
      showerror: action.showerror,
    })
   default:
    return state
  }
 }